import React from "react";
import { Product } from "~/common/Store/models/ProductListing";
import LimitedSaleStockNotice from "~/EventDayPage/LimitedSaleStockNotice";
import { ProductListingView } from "..";
interface LimitedSaleStockNoticeWrapperProps {
  product: Product;
  productListingView: ProductListingView;
  showSaleStockNotice: boolean;
}
const LimitedSaleStockNoticeWrapper = ({
  product,
  productListingView,
  showSaleStockNotice
}: LimitedSaleStockNoticeWrapperProps) => {
  const displayNotice = productListingView === "list" && showSaleStockNotice && product.saleStock?.saleStockLimit && product.saleStock?.remainingSaleQuantity;
  return <>
      {displayNotice && <div style={{
      maxWidth: "150px"
    }} className="ml-auto">
          <LimitedSaleStockNotice saleStockLimit={Number(product.saleStock?.saleStockLimit)} saleStockAvailable={Number(product.saleStock?.remainingSaleQuantity)} />
        </div>}
    </>;
};
export default LimitedSaleStockNoticeWrapper;